module.exports = __webpack_public_path__ + "static/media/bornok_pandapotan_sinaga.f5dfbfa4.jpg";